// src/pages/NotificationsPage/styles.js
import { COLORS, LAYOUT } from '../../constants';

export const notificationsStyles = {
  // Page Container
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: LAYOUT.background,
    padding: '20px',
  },

  // Main container
  container: {
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0'
  },

  // Header
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    marginBottom: '32px',
    padding: '32px',
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #a00e1f 100%)`,
    borderRadius: '16px',
    color: '#ffffff',
    boxShadow: '0 4px 12px rgba(206, 17, 38, 0.2)',
  },

  headerIcon: {
    flexShrink: 0,
  },

  // Page title
  title: {
    color: '#ffffff',
    fontWeight: '700',
    fontSize: '32px',
    margin: '0',
    letterSpacing: '-0.5px',
  },

  subtitle: {
    color: 'rgba(255, 255, 255, 0.9)',
    fontSize: '16px',
    margin: '4px 0 0 0',
  },

  // Notifications List
  notificationsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },

  // Loading state
  loadingState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    textAlign: 'center',
  },

  loadingTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: COLORS.secondary,
    margin: '20px 0 8px 0',
  },

  loadingMessage: {
    fontSize: '16px',
    color: '#666',
    margin: 0,
    maxWidth: '400px',
  },

  // Empty state
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 20px',
    textAlign: 'center',
  },

  emptyTitle: {
    fontSize: '24px',
    fontWeight: '600',
    color: COLORS.secondary,
    margin: '20px 0 8px 0',
  },

  emptyMessage: {
    fontSize: '16px',
    color: '#666',
    margin: 0,
    maxWidth: '400px',
  },

  // Notification group container
  groupContainer: {
    marginBottom: '16px',
    border: '1px solid #e8e8e8',
    borderRadius: '16px',
    background: '#ffffff',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    overflow: 'hidden',
    transition: 'all 0.2s ease',
  },

  // Group header (clickable)
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 24px',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },

  groupHeaderHover: {
    backgroundColor: '#fafbfc',
  },

  // Group content area
  groupContent: {
    flex: 1
  },

  // Group title with count
  groupTitle: {
    fontWeight: '700',
    color: COLORS.secondary,
    fontSize: '18px',
    marginBottom: '4px',
  },

  groupCount: {
    color: '#888',
    fontWeight: '400',
    fontSize: '15px'
  },

  // Sender info
  senderInfo: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  senderName: {
    fontWeight: '600',
    color: COLORS.secondary,
  },

  // Group message
  groupMessage: {
    fontSize: '15px',
    color: '#444',
    marginBottom: '4px',
  },

  // Location info
  locationInfo: {
    fontSize: '14px',
    color: '#666',
    marginTop: '6px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  locationLabel: {
    fontWeight: '500'
  },

  // Expand/collapse hint
  expandHint: {
    fontSize: '13px',
    color: '#999',
    marginTop: '8px'
  },

  // Expand/collapse icon
  expandIcon: {
    fontSize: '24px',
    color: COLORS.primary,
    marginLeft: '16px',
    transition: 'transform 0.2s ease',
  },

  expandIconRotated: {
    transform: 'rotate(180deg)',
  },

  // Expanded content area
  expandedContent: {
    borderTop: '1px solid #f0f0f0',
    background: '#fafbfc',
    padding: '16px',
  }
};